import Typography from "../../Typography/Typography";
import styles from "./DividerText.module.scss";

const DividerText = ({ className, text = "" }) => {
	return (
		<div className={`${styles.dividerComponent} ${className}`}>
			<div className={styles.dividerComponentSection}></div>
			<div className={styles.dividerComponentTextSection}>
				<Typography variant="p2" className={styles.dividerText}>
					{text}
				</Typography>
			</div>
			<div className={styles.dividerComponentSection}></div>
		</div>
	);
};

export default DividerText;
